import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import {FilterKey, keyToEmptyFilter, SearchParams} from 'search/SearchConstants';
import * as SearchPreferences from 'search/SearchPreferences';

function getDefaultLibrarySearchParams(): SearchParams {
  return {
    filters: [
      {
        ...keyToEmptyFilter(FilterKey.TYPES),
        value: [ModelTypeConstants.TEMPLATE_COLLECTION],
      },
    ],
    limit: getSelectedPageSize(),
    offset: 0,
    query: '',
    sorts: SearchPreferences.getAppliedSortsFromUserPreference(NavConstants.Section.TEMPLATE_COLLECTIONS),
  };
}

export default getDefaultLibrarySearchParams;
